import { AccessoryCategory } from '../Constants';

export class ProductDetail {
  label: string;
  value: string;
  detailTooltip: string;
  // djb:refactor to use Contants.Enum
  // accessoryType?: number;
  accessoryType?: AccessoryCategory;
  listViewOnly: boolean;
}

export class ProductDetailFilter {
  label: string;
  value: string;
}
